export enum LoadingState {
  NOT_LOADED,
  LOADING,
  LOADED,
  FAILED,
}

export enum CustomFieldType {
  SINGLESEELCT = 'select',
  RADIOBUTTONS = 'radiobuttons',
  MULTISELECT = 'multiselect',
  MULTICHECKBOXES = 'multicheckboxes',
  CASCADINGSELECT = 'cascadingselect',
  SOURCESENSEMULTILEVELCASCADING = 'multi-level-cascading-select',
}

export const fieldTypeStringToEnum = (fieldType: string): CustomFieldType => {
  if (fieldType === 'select') return CustomFieldType.SINGLESEELCT;
  if (fieldType === 'radiobuttons') return CustomFieldType.RADIOBUTTONS;
  if (fieldType === 'multiselect') return CustomFieldType.MULTISELECT;
  if (fieldType === 'multicheckboxes') return CustomFieldType.MULTICHECKBOXES;
  if (fieldType === 'cascadingselect') return CustomFieldType.CASCADINGSELECT;
  if (fieldType === 'multi-level-cascading-select') return CustomFieldType.SOURCESENSEMULTILEVELCASCADING;
  return CustomFieldType.SINGLESEELCT;
};

export interface ValidationError {
  name: string;
  message: string;
}
export interface ValidationErrors {
  errors: ValidationError[];
}

export class AuthenticatedUserCapabilities {
  // DEFAULT VALUES NEEDED WHEN NOT LOADED FROM API YET!
  public userAllowedToDeleteOptions: boolean = false;
}

export class IdAndValue {
  constructor(public id: string, public value: string) {}
}
